<template>

    <div class="or-header">
        <div class="layout-1200 flex-row row-space-between row-ver-center">
            <div class="logo">
                <img class="logo-img" src="../../assets/logo.png" alt="logo"/>
            </div>
            <div class="menu">
                <or-page-select/>
            </div>
            <div class="phone">
                <p class="phote-text">{{info ? info.phone : null}}</p>
            </div>
            <div class="button">
                <or-button @click="toFeedback('name')" 
                           :options="{
                                    text: 'Связаться с нами',
                                    class: 'fill-button',
                                    style: {
                                        width: '156px',
                                        height: '32px',
                                        borderRadius: '4px',
                                    },
                                    animation: 'anim-main-button'
                                    }"/>
            </div>
        </div>

    </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import orPageSelect from "./or-page-select.vue"
import orButton from "./or-button.vue"
export default {
    components: {orPageSelect, orButton},
    computed: {
        ...mapGetters({info: 'getInfo'})
    },
    methods: {
        toFeedback(focus, fill) {
            this.$emit('toFeedback', {focus, fill})
        }
    }
}
</script>

<style scoped>
    .or-header {
        position: relative;
        height: 100px;
        width: 100vw;
        min-width: 1200px;
        /* max-width: 100%; */
        background-color: #000000;
        font-size: 14px;
    }
    .logo-img {
        width: 140px;
    }

</style>